module.exports = "/_next/static/images/breakit-badge-b29d94e9807eed0d5a45651f0cbbcaac.jpg";